import ApprovalButton from './ApprovalButton';

export default ApprovalButton;